export const isFuturo = (data: Date, hhmm: string) => {
  const [h, m] = hhmm.split(":").map(Number);
  const dt = new Date(data);
  dt.setHours(h ?? 0, m ?? 0, 0, 0);
  return dt.getTime() > Date.now();
};
